import { Entity, Column, PrimaryGeneratedColumn, CreateDateColumn, UpdateDateColumn, VersionColumn } from 'typeorm';
@Entity('division')
export class Division {
    @PrimaryGeneratedColumn('increment', {
        name: 'id'
    })
    id: number;

    @Column('varchar', {
        name: 'client_name'
    })
    clientName: string;

    @Column('varchar', {
        name: 'division_name'
    })
    divisionName: string;

    @Column('varchar', {
        name: 'division_code'
    })
    divisionCode: string;

    @Column('varchar', {
        name: "address"
    })
    Address: string;

    @Column('char', {
        name: "mobile_no"
    })
    mobileNo: string;

    @Column('varchar', {
        name: "gst_number"
    })
    gstNumber: string;

    @CreateDateColumn({ name: 'created_at' })
    createdAt: Date;

    @Column('varchar', {
        name: "created_user"
    })
    createdUser: string;

    @UpdateDateColumn({ name: 'updated_at' })
    updatedAt: Date;

    @Column('varchar', {
        name: "updated_user"
    })
    updatedUser: string;

    @Column('varchar', {
        name: "client_code"
    })
    clientCode: string;

    @Column('varchar', {
        name: "rep_color"
    })
    repColor: string;

    @Column('varchar', {
        name: "client_id"
    })
    clientId: string;
    name: any;
}